
<template>  
    <!-- 求职保障 -->
    <!-- 非会员 -->
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate == 1 || cvipMes.cvipstate == 10)">
        <p class="des">特权介绍：<span class="des-in">开通会员，保障求职效果！若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！</span></p>
        <div class="qzbz-bg">
            <p class="des-title">— 理赔说明 —</p>
            <p class="des-text">不同市场会员赔付金额如下（全额赔付）：</p>
            <ul class="items">
                <li class="item">
                    <div class="des-time">会员套餐</div>
                    <div class="desc price">价格</div>
                    <div class="desc money">赔付价格</div>
                </li>
                <li class="item" v-for="(item, index) in compensateData">
                    <div class="des-time">{{item['time']}}</div>
                    <div class="desc money">{{item['price']}}</div>
                    <div class="desc money">{{item['money']}}</div>
                </li>
            </ul>
        </div>
    </CvipDialog>
    <!-- 会员 -->
    <CvipDialog @btnClick="vipBuy()" @applyCompensate="applyCompensate()" @close="close()" :title="title1" :btnTxt=" vipState === 3 ? '仅新版会员可享受' : vipState === 2 ? '已申请赔付' : btnTxt2 " v-else>
        <p class="tit">恭喜您，已获得<span  class="tit-names">求职保障</span>特权</p>
        <p class="des"><span class="des-in des-use">苦苦等不到面试和电话？若开始找工作（有投递、权益使用、微聊沟通等行为，具体以会员协议中要求为准）后30天之内收不到面试邀请，你将获得高额赔偿！</span></p>
        <div class="qzbz-bg">
            <p class="des-title">— 理赔说明 —</p>
            <p class="des-text">不同市场会员赔付金额如下（全额赔付）：</p>
            <ul class="items">
                <li class="item">
                    <div class="des-time">会员套餐</div>
                    <div class="desc price">价格</div>
                    <div class="desc money">赔付价格</div>
                </li>
                <li class="item" v-for="(item, index) in compensateData">
                    <div class="des-time">{{item['time']}}</div>
                    <div class="desc price">{{item['price']}}</div>
                    <div class="desc money">{{item['money']}}</div>
                </li>
            </ul>
        </div>
    </CvipDialog>
</template>

<script>
    import { mapGetters, mapActions, Store } from 'vuex'
    import CvipDialog from "./common/CvipDialog"
    export default {
        name: 'qzbzDialog',
        components: {
            CvipDialog
        },
        props:{
            vipState: { //会员状态   新版会员 || 老版会员
                type: Number,
                default() {
                    return 0
                }
            }
        },
        data () {
            return {
                title: '无效包赔',
                btnTxt: '开通会员尊享特权',
                title1: '',
                btnTxt1: '',
                title2: '',
                btnTxt2: '申请赔付',
                compensateData: [   //赔付金额数据
                    {
                        time: '7天试用版',
                        price: '18元',
                        money: '100元'
                    },
                    {
                        time: '30天基础版',
                        price: '28元',
                        money: '160元'
                    },
                    {
                        time: '30天升级版',
                        price: '60元',
                        money: '460元'
                    },
                    {
                        time: '30天升级版',
                        price: '60元',
                        money: '880元'
                    }
                ]
            }
        },
        created () {
            window.clickLog && window.clickLog(`from=pc-cvip-qzbz-tanchuang-show-${this.cvipMes.cvipstate}`)
            this.initMealName();
        },
        methods: {
            // 点击支付按钮
            vipBuy () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzbz-ljkt-${this.cvipMes.cvipstate}`)
                this.$emit("buyDialog")
            },
            initMealName() {
                console.log(this.mealInfo.payset)
                this.compensateData[0].time = this.mealInfo.payset.experienceName;
                this.compensateData[1].time = this.mealInfo.payset.basicName;
                this.compensateData[2].time = this.mealInfo.payset.upgradeName;
                this.mealInfo.payset.forEach((mealItem, index) => {
                    this.compensateData[index].time = mealItem.versionName;
                    this.compensateData[index].price = mealItem.benefitsPrice + '元';
                })
            },
            //申请赔付
            applyCompensate () { 
                this.$emit("compensateDialog");
            },
            close () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzbz-close-${this.cvipMes.cvipstate}`)
                this.$emit("closeDialog")
            }
        },
        computed: mapGetters({
            cvipMes: 'cvipMes',
            mealInfo: 'mealInfo',   //会员套餐信息
            rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
        })
    }

</script>

<style lang='scss' scoped>

    .tit{
        margin-top:80px;
    }
    .qzbz-bg{
        width: 567px;
        padding: 20px 60px;
        margin: 28px auto 0;
        overflow: hidden;
        background: #F6F6F6;
        .des-title{
            font-size: 16px;
            color: #AAAAAA;
            text-align: center;
        }
        .des-text{
            margin-top: 40px;
            margin: 40px 0 14px 0;
            font-size: 14px;
            color: #999999;
        }
        .items{
            margin: 20px auto;
            height: 131px;
            border: 1px solid #E5DCCE;
        }
        .item{
            float: left;
            width: 113px;
            box-sizing: border-box;
            border-right: 1px solid #E5DCCE;
            .des-time{
                height: 44px;
                background: #EEE2CF;
                color: #B89860;
                line-height: 44px;
                text-align: center;
                font-weight: bold;
            }
            &:last-child{
                border-right: none;
            }
            .desc{
                height: 43px;
                line-height: 43px;
                font-size: 14px;
                color: #3F3C37;
                text-align: center;
                background: #F3F0EB;
                font-weight: bold;
            }
            .price {
                border-bottom: 1px solid #E5DCCE;
            }
        }
    }
    .qzbz-bg-img{
        width: 606px;
        height: 290px;
    }
    .des-in{
        font-size: 14px;
        color: #AAAAAA;
    }
    .des-use{
        width:100%;
        display:inline-block;
        text-align:center;
    }
    .tit{
        margin: 55px 0 8px;
        font-size: 24px;
        color: #333;
        line-height: 33px;
        text-align:center;
    }
    .tit-names{
        font-size: 24px;
        color: #D4B277;
        line-height: 33px;
    }
</style>





// WEBPACK FOOTER //
// QzbzDialog.vue?63c0981c